import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20warm%20digital%20content%20platform%20abstract%20background%20with%20soft%20gradient%20in%20warm%20orange%20and%20cream%20tones%2C%20minimalist%20geometric%20shapes%2C%20clean%20aesthetic%2C%20editorial%20style%20with%20gentle%20light%20patterns%2C%20no%20text%2C%20abstract%20composition&width=1800&height=900&seq=home-hero-01&orientation=landscape"
        alt="91叔叔内容平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="91叔叔 - 优质内容平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight animate-[fadeInDown_0.8s_ease-out]">
          91叔叔
        </h1>
        <p className="text-base md:text-xl text-white/85 max-w-2xl leading-relaxed mb-8 animate-[fadeInDown_0.8s_ease-out_0.15s] opacity-0 [animation-fill-mode:forwards]">
          深受用户喜爱的内容平台，为您提供优质内容、实用资源与精彩体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 animate-[fadeInDown_0.8s_ease-out_0.3s] opacity-0 [animation-fill-mode:forwards]">
          <Link
            to="/category/guide"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm md:text-base font-medium hover:bg-white/30 transition-all duration-300 whitespace-nowrap border border-white/30"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}